/* eslint-disable */
export default {
  daddh: {
    key_es: 'DADDH',
    key_en: 'ADRDM',
    key_pt: 'DADDH',
    label_es: 'Declaración Americana de los Derechos y Deberes del Hombre',
    label_en: 'American Declaration of the Rights and Duties of Man',
    label_pt: 'Declaração Americana dos Direitos e Deveres do Homem'
  },
  dple: {
    key_es: 'DPLE',
    key_en: 'DPFE',
    key_pt: 'DPLE',
    label_es: 'Declaración de Principios sobre Libertad de Expresión',
    label_en: 'Declaration of Principles on Freedom of Expresion',
    label_pt: 'Declaração de Princípios sobre Liberdade de Expressão '
  },
  pbpppl: {
    key_es: 'PBPPPL',
    key_en: 'PBPPDL',
    key_pt: 'PBPPPL',
    label_es:
    'Principios y Buenas Prácticas sobre la Protección de las Personas Privadas de Libertad en las Américas',
    label_en:
    'Principles and Best Practices on the Protection of Persons Deprived of Liberty in the Americas',
    label_pt: 'Princípios e Boas Prácticas para as Pessoas Privadas de Liberdade nas Américas'
  },
  cadh: {
    key_es: 'CADH',
    key_en: 'ACHR',
    key_pt: 'CADH',
    label_es: 'Convención Americana sobre Derechos Humanos',
    label_en: 'American Convention on Human Rights',
    label_pt: 'Convenção Americana sobre Direitos Humanos'
  },
  'prot-pdm': {
    key_es: 'Prot-PdM',
    key_en: 'Prot-DP',
    key_pt: 'Prot-PdM',
    label_es:
    'Protocolo a la Convención Americana sobre Derechos Humanos relativo a la Abolición de la Pena de Muerte',
    label_en: 'Protocol to the American Convention on Human Rights to Abolish the Death Penalty',
    label_pt:
    'Protocolo à Convenção Americana sobre Direitos Humanos relativo à abolição da Pena de Morte'
  },
  'prot-desc': {
    key_es: 'Prot-DESC',
    key_en: 'Prot-ESCR',
    key_pt: 'Prot-desc',
    label_es: `Protocolo Adicional a la Convención Americana sobre Derechos Humanos en Materia de Derechos Económicos, Sociales y Culturales 'Protocolo de San Salvador'`,
    label_en: `Additional Protocol to the American Convention on Human Rights in the Area of Economic, Social and Cultural Rights 'Protocol of San Salvador'`,
    label_pt: `Protocolo adicional à Convenção Americana sobre Direitos Humanos em matéria de Direitos Econômicos, sociais e culturais 'Protocolo de São Salvador'`
  },
  cipst: {
    key_es: 'CIPST',
    key_en: 'IACPPT',
    key_pt: 'CIPST',
    label_es: 'Convención Interamericana para Prevenir y Sancionar la Tortura',
    label_en: 'Inter-American Convention to Prevent and Punish Torture',
    label_pt: 'Convenção Interamericana para Prevenir e Sancionar a Tortura'
  },
  cidfp: {
    key_es: 'CIDFP',
    key_en: 'IACFDP',
    key_pt: 'CIDFP',
    label_es: 'Convención Interamericana sobre Desaparición Forzada de Personas',
    label_en: 'Inter-American Convention on Forced Disappearance of Persons',
    label_pt: 'Convenção Interamericana sobre Desaparecimento Forçado de Pessoas'
  },
  ciedpd: {
    key_es: 'CIEDPD',
    key_en: 'IACEDAPD',
    key_pt: 'CIEDPD',
    label_es:
    'Convención Interamericana para la Eliminación de todas las Formas de Discriminación contra las Personas con Discapacidad',
    label_en:
    'Inter-American Convention on the Elimination of All Forms of Discrimination Against Persons with Disabilities',
    label_pt:
    'Convenção Interamericana para a eliminação de todas as formas de discriminação contra as pessoas portadoras de deficiência'
  },
  cbdopara: {
    key_es: 'CBdoPara',
    key_en: 'IACBdoPara',
    key_pt: 'CIBdoPara',
    label_es: `Convención Interamericana para Prevenir, Sancionar y Erradicar la Violencia contra la Mujer 'Convención de Belem Do Para'`,
    label_en: `Inter-American Convention on the Prevention, Punishment and Eradication of Violence Against Women 'Convention of Belém Do Pará'`,
    label_pt: `Convenção Interamericana para Prevenir, Punir e Erradicar a violência contra a mulher 'Convenção de Belém do Pará'`
  },
  cicc: {
    key_es: 'CICC',
    key_en: 'IACAC',
    key_pt: 'CICC',
    label_es: 'Convención Interamericana contra la Corrupción',
    label_en: 'Inter-American Convention Against Corruption',
    label_pt: 'Convenção Interamericana contra a corrupção'
  },
  cdi: {
    key_es: 'CDI',
    key_en: 'IADC',
    key_pt: 'CDI',
    label_es: 'Carta Democrática Interamericana',
    label_en: 'Inter-American Democratic Charter',
    label_pt: 'Carta Democrática Interamericana'
  },
  cicdi: {
    key_es: 'CICDI',
    key_en: 'IACDI',
    key_pt: 'CICDI',
    label_es: 'Convención Interamericana contra toda Forma de Discriminación e Intolerancia',
    label_en: 'Inter-American Convention against all forms of Discrimination and Intolerance',
    label_pt: 'Convenção Interamericana contra toda a Forma de Discriminação y Intolerância '
  },
  cirdri: {
    key_es: 'CIRDRI',
    key_en: 'IACRDRI',
    key_pt: 'CIRDRI',
    label_es:
    'Convención Interamericana contra el Racismo, la Discriminación Racial y Formas Conexas de Intolerancia',
    label_en:
    'Inter-American Convention against Racism, Racial Discrimination and related forms of Intolerance',
    label_pt:
    'Convenção Interamericana contra o Racismo, a Discriminação Racial y Formas Correlatas de Intolerância'
  },
  'e-cidh': {
    key_es: 'E-CIDH',
    key_en: 'S-IACHR',
    key_pt: 'E-CIDH',
    label_es: 'Estatuto de la Comisión Interamericana de Derechos Humanos ',
    label_en: 'Statute of the Inter-American Commission on Human Rights',
    label_pt: 'Estatuto da Comissão Interamericana de Direitos Humanos'
  },
  'e-corteidh': {
    key_es: 'E-CorteIDH',
    key_en: 'S-IACoHR',
    key_pt: 'E-CorteIDH',
    label_es: 'Estatuto de la Corte Interamericana de Derechos Humanos ',
    label_en: 'Statute of the Inter-American Court of Human Rights',
    label_pt: 'Estatuto da Corte Interamericana de Direitos Humanos'
  },
  'r-cidh (2013)': {
    key_es: 'R-CIDH (2013)',
    key_en: 'R-IACHR (2013)',
    key_pt: 'R-CIDH (2013)',
    label_es: 'Reglamento de la Comisión Interamericana de Derechos Humanos (2013 – vigente)',
    label_en:
    'Rules of Procedure of the Inter-American Commission on Human Rights (2013 - in force)',
    label_pt: 'Regulamento da Comissão Interamericana de Direitos Humanos (2013 – em vigor)'
  },
  'r-cidh (2011)': {
    key_es: 'R-CIDH (2011)',
    key_en: 'R-IACHR (2011)',
    key_pt: 'R-CIDH (2011)',
    label_es: 'Reglamento de la Comisión Interamericana de Derechos Humanos (2011)',
    label_en: 'Rules of Procedure of the Inter-American Commission on Human Rights (2011)',
    label_pt: 'Regulamento da Comissão Interamericana de Direitos Humanos (2011)'
  },
  'r-cidh (2009)': {
    key_es: 'R-CIDH (2009)',
    key_en: 'R-IACHR (2009)',
    key_pt: 'R-CIDH (2009)',
    label_es: 'Reglamento de la Comisión Interamericana de Derechos Humanos (2009)',
    label_en: 'Rules of Procedure of the Inter-American Commission on Human Rights (2009)',
    label_pt: 'Regulamento da Comissão Interamericana de Direitos Humanos (2009)'
  },
  'r-cidh (2008)': {
    key_es: 'R-CIDH (2008)',
    key_en: 'R-IACHR (2008)',
    key_pt: 'R-CIDH (2008)',
    label_es: 'Reglamento de la Comisión Interamericana de Derechos Humanos (2008)',
    label_en: 'Rules of Procedure of the Inter-American Commission on Human Rights (2008)',
    label_pt: 'Regulamento da Comissão Interamericana de Direitos Humanos (2008)'
  },
  'r-cidh (2006)': {
    key_es: 'R-CIDH (2006)',
    key_en: 'R-IACHR (2006)',
    key_pt: 'R-CIDH (2006)',
    label_es: 'Reglamento de la Comisión Interamericana de Derechos Humanos (2006)',
    label_en: 'Rules of Procedure of the Inter-American Commission on Human Rights (2006)',
    label_pt: 'Regulamento da Comissão Interamericana de Direitos Humanos (2006)'
  },
  'r-cidh (2003)': {
    key_es: 'R-CIDH (2003)',
    key_en: 'R-IACHR (2003)',
    key_pt: 'R-CIDH (2003)',
    label_es: 'Reglamento de la Comisión Interamericana de Derechos Humanos (2003)',
    label_en: 'Rules of Procedure of the Inter-American Commission on Human Rights (2003)',
    label_pt: 'Regulamento da Comissão Interamericana de Direitos Humanos (2003)'
  },
  'r-cidh (2002)': {
    key_es: 'R-CIDH (2002)',
    key_en: 'R-IACHR (2002)',
    key_pt: 'R-CIDH (2002)',
    label_es: 'Reglamento de la Comisión Interamericana de Derechos Humanos (2002)',
    label_en: 'Rules of Procedure of the Inter-American Commission on Human Rights (2002)',
    label_pt: 'Regulamento da Comissão Interamericana de Direitos Humanos (2002)'
  },
  'r-cidh (2000)': {
    key_es: 'R-CIDH (2000)',
    key_en: 'R-IACHR (2000)',
    key_pt: 'R-CIDH (2000)',
    label_es: 'Reglamento de la Comisión Interamericana de Derechos Humanos (2000)',
    label_en: 'Rules of Procedure of the Inter-American Commission on Human Rights (2000)',
    label_pt: 'Regulamento da Comissão Interamericana de Direitos Humanos (2000)'
  },
  'r-cidh (1980)': {
    key_es: 'R-CIDH (1980)',
    key_en: 'R-IACHR (1980)',
    key_pt: 'R-CIDH (1980)',
    label_es: 'Reglamento de la Comisión Interamericana de Derechos Humanos (1980)',
    label_en: 'Rules of Procedure of the Inter-American Commission on Human Rights (1980)',
    label_pt: 'Regulamento da Comissão Interamericana de Direitos Humanos (1980)'
  },
  'r-cidh (1966)': {
    key_es: 'R-CIDH (1966)',
    key_en: 'R-IACHR (1966)',
    key_pt: 'R-CIDH (1966)',
    label_es: 'Reglamento de la Comisión Interamericana de Derechos Humanos (1966)',
    label_en: 'Rules of Procedure of the Inter-American Commission on Human Rights (1966)',
    label_pt: 'Regulamento da Comissão Interamericana de Direitos Humanos (1966)'
  },
  'r-corteidh (2009/noviembre)': {
    key_es: 'R-CorteIDH (2009/noviembre)',
    key_en: 'R-IACoHR (2009/november)',
    key_pt: 'R-CorteIDH (2009/novembro)',
    label_es: 'Reglamento de la Corte Interamericana de Derechos Humanos (2009/noviembre)',
    label_en: 'Rules of Procedure of the Inter-American Court of Human Rights (2009/november)',
    label_pt: 'Regulamento da Corte Interamericana de Direitos Humanos (2009/novembro)'
  },
  'r-corteidh (2009/enero)': {
    key_es: 'R-CorteIDH (2009/enero)',
    key_en: 'R-IACoHR (2009/january)',
    key_pt: 'R-CorteIDH (2009/janeiro)',
    label_es: 'Reglamento de la Corte Interamericana de Derechos Humanos (2009/enero)',
    label_en: 'Rules of Procedure of the Inter-American Court of Human Rights (2009/january)',
    label_pt: 'Regulamento da Corte Interamericana de Direitos Humanos (2009/janeiro)'
  },
  'r-corteidh (2003)': {
    key_es: 'R-CorteIDH (2003)',
    key_en: 'R-IACoHR (2003)',
    key_pt: 'R-CorteIDH (2003)',
    label_es: 'Reglamento de la Corte Interamericana de Derechos Humanos (2003)',
    label_en: 'Rules of Procedure of the Inter-American Court of Human Rights (2003)',
    label_pt: 'Regulamento da Corte Interamericana de Direitos Humanos (2003)'
  },
  'r-corteidh (2000)': {
    key_es: 'R-CorteIDH (2000)',
    key_en: 'R-IACoHR (2000)',
    key_pt: 'R-CorteIDH (2000)',
    label_es: 'Reglamento de la Corte Interamericana de Derechos Humanos (2000)',
    label_en: 'Rules of Procedure of the Inter-American Court of Human Rights (2000)',
    label_pt: 'Regulamento da Corte Interamericana de Direitos Humanos (2000)'
  },
  'r-corteidh (1996)': {
    key_es: 'R-CorteIDH (1996)',
    key_en: 'R-IACoHR (1996)',
    key_pt: 'R-CorteIDH (1996)',
    label_es: 'Reglamento de la Corte Interamericana de Derechos Humanos (1996)',
    label_en: 'Rules of Procedure of the Inter-American Court of Human Rights (1996)',
    label_pt: 'Regulamento da Corte Interamericana de Direitos Humanos (1996)'
  },
  'r-corteidh (1991)': {
    key_es: 'R-CorteIDH (1991)',
    key_en: 'R-IACoHR (1991)',
    key_pt: 'R-CorteIDH (1991)',
    label_es: 'Reglamento de la Corte Interamericana de Derechos Humanos (1991)',
    label_en: 'Rules of Procedure of the Inter-American Court of Human Rights (1991)',
    label_pt: 'Regulamento da Corte Interamericana de Direitos Humanos (1991)'
  },
  'r-corteidh (1980)': {
    key_es: 'R-CorteIDH (1980)',
    key_en: 'R-IACoHR (1980)',
    key_pt: 'R-CorteIDH (1980)',
    label_es: 'Reglamento de la Corte Interamericana de Derechos Humanos (1980)',
    label_en: 'Rules of Procedure of the Inter-American Court of Human Rights (1980)',
    label_pt: 'Regulamento da Corte Interamericana de Direitos Humanos (1980)'
  },
  rcfal: {
    key_es: 'RCFAL',
    key_en: 'RICLAF',
    key_pt: 'RCFAJ',
    label_es:
    'Reglamento de la Comisión Interamericana de derechos humanos sobre el Fondo de Asistencia Legal del Sistema Interamericano de Derechos Humanos',
    label_en:
    'Rules of Procedure of the Inter-American Commission of Human Rights on the Legal Assistance Fund of the Inter-American Human Rights System',
    label_pt:
    'Regulamento da Comissão Interamericana sobre o Fundo de Assistência Jurídica do Sistema Interamericano de Direitos Humanos'
  },
  rcofalv: {
    key_es: 'RCoFALV',
    key_en: 'RCoVLAF',
    key_pt: 'RCoFALV',
    label_es:
    'Reglamento de la Corte Interamericana de derechos humanos sobre el funcionamiento del fondo de asistencia legal de victimas',
    label_en:
    'Rules of Procedure of the Inter-American Court of Human Rights on the Victims Legal Assistance Fund',
    label_pt:
    'Regulamento da Corte Interamericana de Direitos Humanos sobre o funcionamento do Fundo de Assistência Jurídica às Vítimas'
  }
};